/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Pricechart_Fetchingdata2Inputs */

const id_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengambil data terbaru`)
};

const ms_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendapatkan data terkini`)
};

const da_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henter seneste data`)
};

const de_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Daten abrufen`)
};

const en_us2_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching latest data`)
};

const es_es2_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo los últimos datos`)
};

const es_mx2_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo datos recientes`)
};

const fil_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinukuha ang pinakabagong data`)
};

const fr_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération des dernières données`)
};

const it_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero ultimi dati`)
};

const hu_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legfrissebb adatok lekérése`)
};

const nl_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwste gegevens ophalen`)
};

const no_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henter siste data`)
};

const pl_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobieranie najnowszych danych`)
};

const pt_br2_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching latest data`)
};

const pt_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A obter dados mais recentes`)
};

const ro_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se preiau cele mai recente date`)
};

const fi_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haetaan uusimpia tietoja`)
};

const sv_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hämtar senaste data`)
};

const vi_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải dữ liệu mới nhất`)
};

const tr_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En son veriler getiriliyor`)
};

const cs_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání nejnovějších dat`)
};

const bg_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извличане на най-новите данни`)
};

const ru_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получение последних данных`)
};

const uk_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримання останніх даних`)
};

const ar_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جلب أحدث البيانات`)
};

const hi_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम डेटा लाया जा रहा है`)
};

const th_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังดึงข้อมูลล่าสุด`)
};

const ja_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新データを取得中`)
};

const zh_cn2_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching latest data`)
};

const zh_hant1_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching latest data`)
};

const ko_components_pricechart_fetchingdata2 = /** @type {(inputs: Components_Pricechart_Fetchingdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching latest data`)
};

/**
* | output |
* | --- |
* | "Fetching latest data" |
*
* @param {Components_Pricechart_Fetchingdata2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_pricechart_fetchingdata2 = /** @type {((inputs?: Components_Pricechart_Fetchingdata2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Pricechart_Fetchingdata2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_pricechart_fetchingdata2(inputs)
	if (locale === "ms") return ms_components_pricechart_fetchingdata2(inputs)
	if (locale === "da") return da_components_pricechart_fetchingdata2(inputs)
	if (locale === "de") return de_components_pricechart_fetchingdata2(inputs)
	if (locale === "en-US") return en_us2_components_pricechart_fetchingdata2(inputs)
	if (locale === "es-ES") return es_es2_components_pricechart_fetchingdata2(inputs)
	if (locale === "es-MX") return es_mx2_components_pricechart_fetchingdata2(inputs)
	if (locale === "fil") return fil_components_pricechart_fetchingdata2(inputs)
	if (locale === "fr") return fr_components_pricechart_fetchingdata2(inputs)
	if (locale === "it") return it_components_pricechart_fetchingdata2(inputs)
	if (locale === "hu") return hu_components_pricechart_fetchingdata2(inputs)
	if (locale === "nl") return nl_components_pricechart_fetchingdata2(inputs)
	if (locale === "no") return no_components_pricechart_fetchingdata2(inputs)
	if (locale === "pl") return pl_components_pricechart_fetchingdata2(inputs)
	if (locale === "pt-BR") return pt_br2_components_pricechart_fetchingdata2(inputs)
	if (locale === "pt") return pt_components_pricechart_fetchingdata2(inputs)
	if (locale === "ro") return ro_components_pricechart_fetchingdata2(inputs)
	if (locale === "fi") return fi_components_pricechart_fetchingdata2(inputs)
	if (locale === "sv") return sv_components_pricechart_fetchingdata2(inputs)
	if (locale === "vi") return vi_components_pricechart_fetchingdata2(inputs)
	if (locale === "tr") return tr_components_pricechart_fetchingdata2(inputs)
	if (locale === "cs") return cs_components_pricechart_fetchingdata2(inputs)
	if (locale === "bg") return bg_components_pricechart_fetchingdata2(inputs)
	if (locale === "ru") return ru_components_pricechart_fetchingdata2(inputs)
	if (locale === "uk") return uk_components_pricechart_fetchingdata2(inputs)
	if (locale === "ar") return ar_components_pricechart_fetchingdata2(inputs)
	if (locale === "hi") return hi_components_pricechart_fetchingdata2(inputs)
	if (locale === "th") return th_components_pricechart_fetchingdata2(inputs)
	if (locale === "ja") return ja_components_pricechart_fetchingdata2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_pricechart_fetchingdata2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_pricechart_fetchingdata2(inputs)
	return ko_components_pricechart_fetchingdata2(inputs)
});
export { components_pricechart_fetchingdata2 as "components.priceChart.fetchingData" }